/** 处理年份 */
export const generateYearObjects = arr => {
  const result = arr.map(obj => {
    let label;
    if (obj.dictKey.includes("-")) {
      label = `${obj.dictKey.replace("-", "")}年之前`;
    } else {
      label = `${obj.dictKey}年`;
    }
    return {
      label,
      value: obj.dictKey
    };
  });
  return result;
};

/** 处理付费方式和媒资来源 */
/**
 * 格式化数组
 * @param {Array} arr - 原始数组
 * @returns {Array} - 格式化后的数组
 */
export const formatPayType = arr => {
  // 定义sourceType对应关系
  const sourceMap = {
    1: "腾讯",
    2: "优酷",
    3: "爱奇艺",
    8: "Bilibili"
  };

  // 定义payType对应关系
  const payTypeMap = {
    1: "【免费】",
    2: "【VIP】",
    3: "【付费】"
  };

  // 存储结果的数组
  const resultArray = [];

  // 统计各个payType的字符串
  const payTypeStrings = {
    "【付费】": "",
    "【VIP】": "",
    "【免费】": ""
  };

  // 遍历数组进行处理
  arr.forEach(obj => {
    const source = sourceMap[obj.sourceType];
    const payType = payTypeMap[obj.payType];

    // 如果存在sourceType和payType，则进行拼接字符串
    if (source && payType) {
      payTypeStrings[payType] += `${source}、`;
    }
  });

  // 按照payType的顺序添加结果到数组中
  Object.keys(payTypeStrings).forEach(payType => {
    // 去除末尾的分隔符
    const sourceString = payTypeStrings[payType].slice(0, -1);
    // 如果sourceString不为空，则格式化字符串，否则为空字符串
    const formattedString = sourceString ? `${payType} ${sourceString}` : "";
    resultArray.push(formattedString);
  });

  // 返回格式化后的数组
  return resultArray;
};
